const sessions = new Map();
const key = (server, siteId) => JSON.stringify([server, siteId]);
export const setSession = (server, siteId, terminalId) => sessions.set(key(server, siteId), terminalId);
export const clearSession = (server, siteId, terminalId) => {
  if (sessions.get(key(server, siteId)) === terminalId) sessions.delete(key(server, siteId));
};
export const target = (value, model = {}) => {
  const server = value[model.serverIdField || "_id"];
  const siteId = model.serverIdField === "server" ? value._id : undefined;
  return { server, siteId, terminalId: sessions.get(key(server, siteId)) };
};

export default { target, setSession, clearSession };
